import { useState, useEffect } from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import SectionRanking from './components/SectionRanking';
import SectionFAQ from './components/SectionFAQ';
import SectionMedia from './components/SectionMedia';
import SectionComments from './components/SectionComments';
import SectionFeatures from './components/SectionFeatures';
import SectionContact from './components/SectionContact';
import SectionApp from './components/SectionApp';
import SectionTopics from './components/SectionTopics';
import SectionCarousel from './components/SectionCarousel';
import SectionIndex from './components/SectionIndex';
import SectionAbout from './components/SectionAbout';
import SectionCards from './components/SectionCards';
import SectionUpdates from './components/SectionUpdates';
import Footer from './components/Footer';

export default function Home() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest('a[href^="#"]');
      if (!anchor) return;
      const href = anchor.getAttribute('href');
      if (!href || href === '#') return;
      const el = document.querySelector(href);
      if (el) {
        e.preventDefault();
        const top = el.getBoundingClientRect().top + window.scrollY - 76;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    };
    document.addEventListener('click', handleAnchorClick);
    return () => document.removeEventListener('click', handleAnchorClick);
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Header scrolled={scrolled} />
      <main>
        <HeroSection />
        <SectionRanking />
        <SectionFAQ />
        <SectionMedia />
        <SectionComments />
        <SectionFeatures />
        <SectionContact />
        <SectionApp />
        <SectionTopics />
        <SectionCarousel />
        <SectionIndex />
        <SectionAbout />
        <SectionCards />
        <SectionUpdates />
      </main>
      <Footer />
    </div>
  );
}